import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { DownloadIconWrapper } from '../../../styles';
import { getOrderInvoice } from '../../../../../api/order';
import { openErrorToast } from '../../../../../reducers/uiLogic';
import store from '../../../../../store';
import { DownloadInvoice } from '../../../../../components/SVGs/commonSVGs';

const InvoiceDownloadCell = ({ row }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = useCallback(async () => {
    if (loading) return;
    setLoading(true);
    try {
      const res = await getOrderInvoice(row.order_id);
      if (res && res.data && res.data.invoice_url) {
        const link = document.createElement('a');
        link.href = res.data.invoice_url;
        link.download = `ORDER_${row.order_id}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        store.dispatch(openErrorToast(res.message || 'Failed to download invoice'));
      }
    } catch {
      store.dispatch(openErrorToast('Failed to download invoice'));
    } finally {
      setLoading(false);
    }
  }, [row.order_id, loading]);

  return (
    <DownloadIconWrapper onClick={handleDownload}>
      {loading ? (
        <span
          style={{
            display: 'inline-block',
            width: '16px',
            height: '16px',
            border: '2px solid #ccc',
            borderTop: '2px solid #333',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
          }}
        />
      ) : (
        <DownloadInvoice />
      )}
    </DownloadIconWrapper>
  );
};

InvoiceDownloadCell.propTypes = {
  row: PropTypes.shape({
    order_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
};

export default InvoiceDownloadCell;
